import { render } from "./PayrollDetailsRow.vue?vue&type=template&id=5d7af2e4&ts=true"
import script from "./PayrollDetailsRow.ts?vue&type=script&lang=ts&external"
export * from "./PayrollDetailsRow.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__